import React from "react";
import { useTranslation } from 'react-i18next';
import "./TrafficFlow.css";
import { FaChartLine, FaLightbulb, FaHandshake, FaChartBar } from 'react-icons/fa';

const TrafficFlow = () => {
  const { t } = useTranslation();

  return (
    <section className="traffic-flow-section">
      <div className="container">
        <h2 className="section-title">
          {t('trafficFlow.title')}
        </h2>
        
        <div className="flow-grid">
          <div className="flow-item">
            <div className="flow-icon">
              <FaLightbulb />
            </div>
            <h3>{t('trafficFlow.items.diagnostic.title')}</h3>
            <p>{t('trafficFlow.items.diagnostic.description')}</p>
            <div className="flow-connector"></div>
          </div>

          <div className="flow-item">
            <div className="flow-icon">
              <FaChartLine />
            </div>
            <h3>{t('trafficFlow.items.solution.title')}</h3>
            <p>{t('trafficFlow.items.solution.description')}</p>
            <div className="flow-connector"></div>
          </div>

          <div className="flow-item">
            <div className="flow-icon">
              <FaHandshake />
            </div>
            <h3>{t('trafficFlow.items.partnership.title')}</h3>
            <p>{t('trafficFlow.items.partnership.description')}</p>
            <div className="flow-connector"></div>
          </div>

          <div className="flow-item">
            <div className="flow-icon">
              <FaChartBar />
            </div>
            <h3>{t('trafficFlow.items.results.title')}</h3>
            <p>{t('trafficFlow.items.results.description')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrafficFlow;